module.exports = "<div class=\"text-small margin-md\">\r\n  {{$ctrl.leyenda}}\r\n</div> ";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/shared/item/status/template.html
// module id = 3374
// module chunks = 0